<template>
  <el-dialog
    v-dialogDrag
    :visible.sync="searchCard"
    :before-close="closeCard"
    :title="dialogTitle"
    :close-on-click-modal="false"
    :modal="false"
  >
    <div class="search">
      <el-input v-model="keyWord" class="inputW" :placeholder="$t('searchHome.tips2')" clearable />
      <el-button type="primary" @click="handleFilter">{{ $t('common.commonSearch') }}</el-button>
    </div>
    <el-tabs
      v-if="editableTabs && editableTabs.length > 0" 
      v-model="activeNameSearch" 
      class="advancedSearch"
      style="height: calc(100vh - 240px);" 
      @tab-click="handleClickSearch"
    >
      <el-tab-pane
        v-for="(item) in editableTabs"
        :key="item.docType"
        :label="`${$t(`documentTypes.${item.docType}`)} (${item.total})`"
        :name="item.docType"
      >
        <el-table
          :key="tableKey"      
          v-loading="dataLoading"     
          highlight-current-row
          :data="dataOption"
          style="width: 100%"
          border
          height="calc(100vh - 340px)"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        >
          <el-table-column
            v-if="dataOption.length"
            :label="$t('technical.technical13')"
            align="left"
            width="160"
          >
            <template slot-scope="{ row }">
              <span>{{ row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="dataOption.length"
            :label="$t('notice.notice4')"
            align="left"
            min-width="100"
          >
            <template slot-scope="{ row }">
              <span>{{ row.text }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="dataOption.length"
            :label="$t('table.actions')"
            align="left"
            width="120"
          >
            <template slot-scope="{ row }">
              <el-button type="primary" @click="getUrl(row.href, row.root)">{{ $t('technical.technical15') }}</el-button>
            </template>
          </el-table-column>
        </el-table>  
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pageIndex"
          :limit.sync="pageSize"
          @pagination="handleFilter"
        />      
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import getVinApi from '@/api/epc/getVin-api'
import { EventBus } from '@/api/epc/event-bus.js';
import Pagination from '@/components/Pagination'
export default {
  name: 'AdvancedSearch',
  components: { Pagination },
  props: {
     vinPage: {
        type: Boolean,
        default: false
     }
  },
  data() {
    return {
      listLoading: true,
      corsUrl: process.env.VUE_APP_COS_URL,
      dialogVisible: false,
      dialogTitle: this.$t('routeVehicle.vehicle38'),
      dataLoading: false,
      activeNameSearch: '',
      searchCard: false,
      keyWord: '',
      tableKey: 0,
      total: 0,
      pageIndex: 1,
      pageSize: 50,
      editableTabs: [],
      dataOption: [],
      matlCode: []
    }
  },
  created() {
    this.matlCodeStorage =  sessionStorage.getItem("matlCodeEs")
  },
  methods: {
    handle(returnMatlCode) {
      console.log(returnMatlCode);
      this.searchCard = true  
      if (returnMatlCode && returnMatlCode.length > 0) {
        sessionStorage.removeItem("epcVin");
        this.matlCode = returnMatlCode
      } else {
        this.matlCode = this.matlCodeStorage.split()
      }
    },
    handleFilter() {
      const addForm = {
        materialCode: this.matlCode,
        showType: this.activeNameSearch,
        text: this.keyWord,
        vin: sessionStorage.getItem("searchVin"),
        pageNumber: this.pageIndex,
        pageSize: this.pageSize
      }
      if (this.keyWord) {
        this.dataLoading = true
        this.dataOption = []
        getVinApi.getEsQueryList(addForm).then(response => {
          if (response.code === 200) {
            this.dataLoading = false
            this.editableTabs = response.data.typeList
            this.showType = response.data.showType
            this.dataOption = response.data.docList
            this.activeNameSearch = this.showType
            this.total = response.data.total
          } else {
            this.dataLoading = false
            this.editableTabs = []
            this.showType = ''
            this.activeNameSearch = ''
            this.total = 0
            this.dataOption = []
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: this.$t('searchHome.tips2'),
          showClose: true,
          duration: 2 * 1000
        })
      }
    },
    handleClickSearch(tab) {
      this.activeNameSearch = tab.name
      this.getTableList(tab.name)
    },
    getUrl(url, root) {
      if (this.showType === 'c3d_atlas') {
        const formData = {
          href: url,
          showType: this.showType,
          vin: sessionStorage.getItem("searchVin")
        }
        getVinApi.getC3Durl(formData).then(response => {
          if (response.code === 200) {
            EventBus.$off('getC3d')
            this.$router.push({ 
                path: '/repairMaterial/modelNavigation',
                query: { returnEsC3dUrl: response.data.url, returnEsCode: response.data.groupCode, returnEsSubCode: response.data.subGroupCode  }
              }, () => {
              EventBus.$emit('getC3d');
            })
          }
        })
      } else if (this.showType === 'warranty_manual' || this.showType === 'user_manual') {
        window.open(this.corsUrl + '/' + root, '_blank', 'height=700,width=1080')
      } else {
        window.open(this.corsUrl + '/' + url, '_blank', 'height=700,width=1080')
      }
    },
    getTableList(name) {
      this.dataLoading = true
      this.dataOption = []
      this.pageIndex = 1
      this.total = 0
      const addForm = {
        materialCode: this.matlCode,
        showType: name,
        vin: sessionStorage.getItem("searchVin"),
        text: this.keyWord,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize
      }
      getVinApi.getEsQueryList(addForm).then(response => {
        if (response.code === 200) {
          this.dataLoading = false
          this.editableTabs = response.data.typeList
          this.showType = response.data.showType
          this.dataOption = response.data.docList
          this.total = response.data.total
        } else {
          this.dataOption = []
          this.dataLoading = false
          this.total = 0
        }
      })
    },
    getConfigList() {
      const formData = {
          vehConfig: this.form.matlCode
        }
        getVinApi.getVehConfigList(formData).then(response => {
          if (response.code === 200) {
             this.tableData = response.data.configList
             if (this.tableData.length > 0 && this.tableData) {
              this.tableCol = this.tableData[0].model
             }           
          }
        })
    },
    getAdvancedSearch() {
      this.searchCard = true
    },
    closeCard() {
      this.searchCard = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .inputW{
  width: 300px;
  }
  .search{
    background-color: #fff;
  }
</style>
